import TableComponent from 'component/molecules/Table/TableComponent';
import NewRole from 'component/molecules/users/new-role/NewRole';
import { userEndpoints } from 'hooks/endpoints';
import { usePost } from 'hooks/usePost';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as tableHeader from './factory/usersHeader';
import ConfirmationModal from 'component/hoc/success-modal/ConfirmationModal';
import UploadModal from 'component/hoc/upload-modal/UploadModal';
import styles from './UsersTab.module.scss';
import { exportData } from 'helpers/exportData';
import { userToast } from 'helpers/toastMessages';
import Tooltip from 'component/Custom/tooltip/Tooltip';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const UsersTab = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const { mutate: uploadFiles } = usePost({
    onSuccessToast: userToast.bulkUpload,
    toastType: 'add',
  });

  const handleExport = async () => {
    exportData(userEndpoints.exportUsersTable(), 'users');
  };

  const { mutate: bulkDelete, isPending } = usePost({
    onSuccessToast: userToast.delete,
    toastType: 'add',
  });

  const handleAdd = () => navigate('/new-user');
  const handleEdit = (item) => navigate(`/edit-user/${item.userId}`);
  const handleRowClick = (item) => navigate(`/user/${item.userId}`);

  const handleChangeRole = (items) => {
    setSelectedItems(items);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setSelectedItems([]);
    setIsModalOpen(false);
    setIsDeleteModalOpen(false);
  };

  const handleDownloadTemplate = () => {
    const filePath = '/documents/SampleGroupUsers.xlsx';
    const a = document.createElement('a');
    a.href = process.env.PUBLIC_URL + filePath;
    a.download = 'SampleGroupUsers.xlsx';

    a.click();
  };

  const handleDelete = () => {
    bulkDelete(
      { url: userEndpoints?.bulkDeleteUsers(), data: selectedItems },
      {
        onSuccess: () => {
          setIsDeleteModalOpen(false);
          setRefetch(true);
        },
      }
    );
  };

  const handleUploadFiles = () => {
    selectedFiles?.map((file, index) => {
      const formData = new FormData();
      formData.append('FileToUpload', file);
      uploadFiles(
        {
          url: userEndpoints.bulkUploadUsers(),
          data: formData,
          requireAuth: true,
        },
        {
          onSuccess: () => {
            setRefetch(!refetch);
            if (index === selectedFiles.length - 1) {
              setShowUploadModal(false);
            }
          },
        }
      );
    });
  };

  const filterButtons = [
    {
      buttonType: 'button',
      label: 'Delete Selected',
      func: (items) => (setIsDeleteModalOpen(true), setSelectedItems(items)),
      foreignState: true,
      variant: 'danger',
    },
    {
      buttonType: 'button',
      label: 'Change Selected Role',
      func: handleChangeRole,
      foreignState: true,
      variant: 'light',
    },
    {
      type: 'plus',
      label: 'Add User',
      func: handleAdd,
    },
  ];
  const renderIsLocked = ({ header, item }) => {
    return header?.hasLock && item?.isLocked ? (
      <Tooltip content='Locked'>
        <SvgWithBranding type='lock' className={styles.icon} />
      </Tooltip>
    ) : null;
  };
  return (
    <>
      <TableComponent
        rowKey='userId'
        headerData={tableHeader.headerData}
        isRefetch={refetch}
        actions={{
          hasEdit: { func: handleEdit },
          onRowClick: { hasRowClick: true, func: handleRowClick },
        }}
        renderAdditionalComponent={renderIsLocked}
        filterButtons={filterButtons}
        api={{
          get: {
            url: userEndpoints?.getCompanyUsers,
            queryKey: 'companyUsers',
          },
          delete: {
            url: userEndpoints?.deleteUser,
            toast: userToast.delete,
            blockDelete: true,
          },
        }}
        handleExport={handleExport}
        handleUploadCSV={() => {
          setShowUploadModal(true);
        }}
        noDataIcon='noUser'
        noDataText='No User Found'
      />
      <NewRole
        isOpen={isModalOpen}
        onClose={handleClose}
        selectedItems={selectedItems}
        setRefetch={setRefetch}
        refetch={refetch}
      />
      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={handleClose}
        onSubmit={handleDelete}
        closeOnSubmit={true}
        onApproveButton={{ text: 'delete' }}
        text='Deleting Users'
        subText='Will remove all their data, including associated files and permissions. Proceed?'
        isLoading={isPending}
      />
      <UploadModal
        title='Upload File'
        isOpen={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        setSelectedFiles={setSelectedFiles}
        handleSubmit={() => handleUploadFiles()}
        footer={
          <div>
            <span
              className={styles['download-template']}
              onClick={handleDownloadTemplate}
            >
              Download CSV Template
            </span>
          </div>
        }
      />
    </>
  );
};

export default UsersTab;
